import React from 'react';
import { randomID } from '../../core/utils';
import S from './style/styled';
export var Loader = function Loader(_ref) {
  var color = _ref.color,
      id = _ref.id,
      inline = _ref.inline;
  return React.createElement(S.StyledLoaderContainer, {
    id: "rc-loaderContainer-".concat(id || randomID),
    color: color,
    inline: inline
  }, React.createElement("span", null), React.createElement("span", null), React.createElement("span", null));
};